import React from 'react';
import classNames from 'classnames';
import Slider from "react-slick";

import { Title } from '../title';
import { Picture } from '../picture';

const sliderSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false
};

export class ContentHead extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get className () {
    return classNames({
      'content-head': true,
      'content-head--reversed': this.props.reversed,
      'content-head--video': this.props.video !== undefined,
    })
  }

  stopSlider = () => {
    this.refs.slider.slickPause();
  }

  render () {
    return (
      <section className={this.className} style={{ backgroundColor: this.props.backgroundColor }}>
        <div className="content-head__left">
          <Title content={ this.props.title } animated />
        </div>
        <div className="content-head__right">
          <div className="content-head__right__image">
            {!this.props.video && (
            <Slider {...sliderSettings} ref="slider" onClick={this.stopSlider}>
              { this.props.images?.map(image => {
                const url = `${image.image?.file?.url}?w=1200&h=800&fm=jpg&fit=fill&f=${ image.focusPoint || 'center' }`;
                return <Picture key={image.id} image={image.image} src={url} />;
              })}
            </Slider>
            )}
            {this.props.video && (
              <div className="filling-image">
                <div className="filling-image__video">
                  <video src={this.props.video.file.url} muted autoPlay loop playsInline></video>
                  {/* <pre>{JSON.stringify(this.props.video, null, 2)}</pre> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}
